export const allowedDocStatus = {
  spainMarketAllowedDocStatus: [
    "Not Submitted",
    "Draft",
    "Reviewed with Minor Changes",
    "Approved with Minor Changes",
    null,
  ],
  usMarketAllowedDocStatus: [
    "Not Submitted",
    "Draft",
    "Business Owner Review Complete",
    "AWC: Agency Updates",
    "AWC: Validate Changes (Business Owner)",
    "Revise and Resubmit for Review",
    "Approved Without Submission",
    "Revise and Resubmit for Final Approval",
    null,
  ],
  israelMarketAllowedDocStatus: [
    "Not Submitted",
    "Draft",
    "Reviewed with Minor Changes",
    "Approved with Minor Changes",
    null,
  ],
  greeceMarketAllowedDocStatus: [
    "Not Submitted",
    "Draft",
    "Reviewed with Minor Changes",
    "Approved with Minor Changes",
    null,
  ],
  switzerlandMarketAllowedDocStatus: [
    "Not Submitted",
    "Draft",
    "Reviewed with Minor Changes",
    "Approved with Minor Changes",
    null,
  ],
  belgiumMarketAllowedDocStatus: [
    "Not Submitted",
    "Draft",
    "Reviewed with Minor Changes",
    "Approved with Minor Changes",
    null,
  ],
  netherlandMarketAllowedDocStatus: [
    "Not Submitted",
    "Draft",
    "Reviewed with Minor Changes",
    "Approved with Minor Changes",
    null,
  ],
  defaultAllowedDocStatus: [
    "Not Submitted",
    "Draft",
     null,
  ],
}

const allowedProductList = {
  usMarketAllowedProductList: [
    "BIKTARVY",
    "TRODELVY",
    "YESCARTA",
  ],
}


export const isDisabled = ({
  bannerExpiryStatus,
  marketName,
  latestMLRStatus,
  mlrStatus,
}) => {
  if (bannerExpiryStatus === "Expired") {
    return true;
  }

  const currentStatus = latestMLRStatus ?? mlrStatus;

  let allowedStatuses = allowedDocStatus.defaultAllowedDocStatus;

  if (marketName === "United States") {
    allowedStatuses = allowedDocStatus.usMarketAllowedDocStatus;
  } else if (marketName === "Spain") {
    allowedStatuses = allowedDocStatus.spainMarketAllowedDocStatus;
  } else if (marketName === "Israel") {
    allowedStatuses = allowedDocStatus.israelMarketAllowedDocStatus;
  } else if (marketName === "Greece & Cyprus") {
    allowedStatuses = allowedDocStatus.greeceMarketAllowedDocStatus;
  } else if (marketName === "Switzerland") {
    allowedStatuses = allowedDocStatus.switzerlandMarketAllowedDocStatus;
  } else if (marketName === "Belgium - Luxemburg") {
    allowedStatuses = allowedDocStatus.belgiumMarketAllowedDocStatus;
  } else if (marketName === "Netherlands") {
    allowedStatuses = allowedDocStatus.netherlandMarketAllowedDocStatus;
  }

  return !allowedStatuses.includes(currentStatus);
};